import { useLang } from "@/lib/i18n";

export const Marquee = () => {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee];
  return (
    <section className="marquee-wrap relative overflow-hidden border-y border-white/10 bg-[#0B1F3A] py-8 lg:py-10" data-testid="marquee">
      <div className="marquee-track flex w-max items-center whitespace-nowrap">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className={`px-6 lg:px-10 text-5xl lg:text-7xl tracking-tight ${i % 2 ? "font-serif-i text-white" : "font-extrabold uppercase stretch-condensed text-outline"}`}>{w}</span>
            <span className="w-3 h-3 rounded-full bg-[#2DD4BF]" />
          </span>
        ))}
      </div>
    </section>
  );
};
